import styled from "styled-components";
import { ButtonStyle } from "../../Styles";

export const HoverButton = styled(ButtonStyle)`
  position: relative;
  &::after,
  &::before {
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%) translateY(-100%) scale(1);
  }

  &:hover::before {
    content: ${(props) => props.hover && "'" + props.hoverData + "'"};
    text-align: center;
    padding: 1rem;
    background-color: black;
    font-weight: normal;
    width: max-content;
    color: white;
    border-radius: 0.5rem;
  }
`;

export const FileUpload = styled.label`
  position: relative;
  display: inline-block;
  padding: 0.6em 1em;
  cursor: pointer;
  border-radius: 5px;
  font-weight: bold;
  color: #0071bc;
  border: 1px solid currentColor;

  input[type="file"] {
    position: absolute;
    z-index: -3;
  }

  &::after {
    font-family: "FontAwesome";
    content: "\f093";
    padding-left: 1em;
  }

  &:hover {
    background-color: #39b54a;
    border: 1px solid currentColor;
    color: white;
  }
`;

export const Container = styled.form`
  color: #8290a2;
  padding: 0 0 0 20px;
  label {
    font-weight: 500;
  }
  input[type="checkbox"],
  input[type="radio"] {
    margin: 4px 10px 0 0;
    margin-top: 1px;
    line-height: normal;
  }
  select {
    height: 48px;
    margin-bottom: 10px;
  }
  input[type="file"] {
    height: 48px;
    margin-bottom: 10px;
  }
  @media screen and (max-width: 767px) {
    padding: 0;
  }
`;

export const Header = styled.h1`
  width: 100%;
  float: left;
  margin: 15px 0 20px;
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  border-bottom: 1px solid #8da3aa;
  padding-bottom: 15px;
`;

export const Button = styled(ButtonStyle)`
  float: right;
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export const Status = styled.div`
  float: left;
  margin-top: 20px;
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;
